import React, { useState } from 'react';
import { Keyboard, Text, View } from 'react-native';
import { TextInput } from 'react-native-web';

import ServiceRowTouchable from './ServiceRowTouchable';
import { Add_type_str } from '../../../utils/DictionaryManagementUtils';

const TableText = ({
  text = '',
  onChangeValue,
  notChosenServices,
  clearInputOnSubmit,
  onPress,
  isMergingAuto,
  isDefaultRow,
  isTypeIdColumn,
}) => {
  const [inputText, setInputText] = useState(text);
  const [isOpenBox, setIsOpenBox] = useState(false);
  const myStyles = {
    txtStyle: {
      fontSize: 14,
      marginHorizontal: isMergingAuto && 'auto',
      color: isDefaultRow && '#A0AEC0',
    },
    popupStyle: {
      backgroundColor: '#ffffff',
      paddingVertical: 18,
      width: 210,
      borderRadius: 8,
      border: 'solid 1.2px #edf2f7',
      boxShadow: '0 0 12px 0 rgba(26, 32, 44, 0.12)',
    },
    textInputStyle: {
      fontSize: 14,
      outline: 'none',
      width: '100%',
    },
  };

  if (!onChangeValue) {
    return (
      <Text style={myStyles.txtStyle}>
        {text}
      </Text>
    );
  }
  return (
    <View>
      <TextInput
        style={myStyles.textInputStyle}
        placeholder={isTypeIdColumn && Add_type_str}
        autoFocus={text === '' && isTypeIdColumn}
        value={inputText}
        multiline={false}
        selectTextOnFocus
        autoCorrect={false}
        onFocus={() => {
          setIsOpenBox(true);
        }}
        onBlur={() => {
          onChangeValue(inputText);
          if (clearInputOnSubmit) {
            setInputText('');
          }

          setTimeout(() => {
            setIsOpenBox(false);
          }, 150);
        }}
        blurOnSubmit={false}
        onChangeText={(newText) => {
          setInputText(newText);
        }}
        onKeyPress={(e) => {
          if (e.nativeEvent.key === 'Enter') {
            Keyboard.dismiss();
          }
        }}
        editable={!!onChangeValue}
      />
      {isOpenBox && notChosenServices
            && (
            <View style={myStyles.popupStyle}>
              {(isOpenBox && notChosenServices)
                    && (
                      notChosenServices
                        .filter((serviceRepresentation) => serviceRepresentation.toLowerCase().includes(inputText.toLowerCase()))
                        .map((serviceRepresentation) => (
                          <ServiceRowTouchable
                            chosenServices={serviceRepresentation}
                            onPress={onPress}
                            key={serviceRepresentation}
                          />
                        )))}
            </View>
            )}
    </View>
  );
};
export default TableText;
